module.exports = __webpack_public_path__ + "img/registerImg.4d0d0739.png";